import React from 'react';
import { Navbar } from 'react-bootstrap';
import './FooterComponent.css';

function FooterComponent() {

  return (
    <Navbar className="footer" fixed="bottom" />
  );
}

export default FooterComponent;